import { render, staticRenderFns } from "./lafiaTravelerDetail.vue?vue&type=template&id=b4a535de"
import script from "./lafiaTravelerDetail.vue?vue&type=script&lang=js"
export * from "./lafiaTravelerDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../makeup-web/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports